import { IMG_2kLJKdokoXhqvWibaAQQq1 } from '@ecomm/contentful-media'
import { useTranslation } from '@ecomm/i18n'
import { AlarmMomentsTab } from '@ecomm/shared-components/v2/lib/AlarmMoments/AlarmMomentsTab'

export function TabTemp() {
  const { t } = useTranslation('alarm-moments')
  const details = [
    {
      icon: 'Siren',
      text: t('detail.temp-alert')
    },
    {
      icon: 'PhoneRinging',
      text: t('detail.sensor-app-notification')
    },
    {
      icon: 'Phone',
      text: t('detail.sensor-phone-call')
    },
    {
      icon: 'Video',
      text: t('detail.recording-investigation')
    }
  ] as const
  return (
    <AlarmMomentsTab
      image={IMG_2kLJKdokoXhqvWibaAQQq1}
      details={details}
      theme="dark"
    />
  )
}
